if (!customElements.get('variant-picker')) {
  class VariantPicker extends window.BaseComponent {
    constructor() {
      super();
    }

    init() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.sectionId = this.dataset.section;
      this.updateOptions();
      this.addEventListener('change', this.onOptionChange.bind(this));

      // Handle deep linking on load — defer so Swiper/Lenis are fully ready
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (variantId) {
        setTimeout(() => this.selectVariantById(variantId), 500);
      } else {
        // Sync initial state from pre-checked radios if no deep link
        this.onOptionChange();
      }
    }

    onOptionChange() {
      // Freeze Lenis to prevent scroll position corruption during DOM changes
      const mainContent = document.getElementById('MainContent');
      const scrollBefore = mainContent ? mainContent.scrollTop : 0;

      if (window.lenis) window.lenis.stop();

      this.updateOptions();
      this.currentVariant = this.variants.find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });

      if (this.currentVariant) {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();

        if (window.pubsub) {
          window.pubsub.publish('variant-change', this.currentVariant);
        }

        // Wait for Swiper autoHeight transition (300ms CSS) to complete,
        // then recalculate Lenis dimensions and resume scrolling
        setTimeout(() => {
          // Restore native scrollTop in case Lenis or Swiper moved it
          if (mainContent) mainContent.scrollTop = scrollBefore;

          if (window.lenis) {
            window.lenis.resize();
            window.lenis.start();
          }
        }, 400);
      } else {
        // No variant found — just resume Lenis
        if (window.lenis) window.lenis.start();
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('input:checked'), (input) => input.value);
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const section = document.getElementById(`ProductSection-${this.sectionId}`) || document;
      const productForms = section.querySelectorAll('form[data-type="add-to-cart-form"], #product-form');
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.removeAttribute('disabled');
      });
    }

    renderProductInfo() {
      // Scope all queries to the product section to avoid hitting
      // dynamic checkout button elements or other unrelated DOM
      const section = document.getElementById(`ProductSection-${this.sectionId}`) || document;

      // Update Price — only target our own .product__price elements
      const priceContainers = section.querySelectorAll('.product__price[data-price]');
      priceContainers.forEach(container => {
        container.textContent = this.formatMoney(this.currentVariant.price);
      });

      // Update ATC Button — only target our own submit button with [data-atc-text]
      const atcButtons = section.querySelectorAll('button[name="add"]');
      atcButtons.forEach(button => {
        const textSpan = button.querySelector('[data-atc-text]');
        if (!textSpan) return;

        if (this.currentVariant.available) {
          button.removeAttribute('disabled');
          const atcLabel = this.dataset.preorder === 'true'
            ? (this.dataset.preorderLabel || 'PRE-ORDER')
            : (this.dataset.addToCartLabel || 'ADD TO CART');
          textSpan.textContent = atcLabel;
        } else {
          button.setAttribute('disabled', 'disabled');
          textSpan.textContent = 'SOLD OUT';
        }
      });
    }

    selectVariantById(id) {
      const variant = this.variants.find(v => v.id == id);
      if (variant) {
        variant.options.forEach((option, index) => {
          const radio = this.querySelector(`input[value="${option}"]`);
          if (radio) radio.checked = true;
        });
        this.onOptionChange();
      }
    }

    formatMoney(cents) {
      // Simple formatter, in a real theme use Shopify.formatMoney if available
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  if (window.BaseComponent) {
    customElements.define('variant-picker', VariantPicker);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.BaseComponent) customElements.define('variant-picker', VariantPicker);
    });
  }
}
